import { DailyFilter } from 'searchCards';
import { RefineClub } from 'searchCards/RefineClubs';
import {
  MatchInfoGroup,
  PlayerGroup,
  RefineTenGameAverageScore,
} from 'searchCards/nba/cardFilters';

const MAX_TEAM_LIMIT = 30;

export const scoutingCenterMarketFilters = [
  MatchInfoGroup,
  PlayerGroup({ withClub: true, withoutActiveClub: true }),
];

export const scoutingCenterMarketDropdownFilters = [
  RefineClub(MAX_TEAM_LIMIT),
  DailyFilter,
  RefineTenGameAverageScore,
];
